// extracted by mini-css-extract-plugin
export var box = "SliderButton-module--box--c5061";
export var box_md = "SliderButton-module--box_md--bcd15";
export var box_xmd = "SliderButton-module--box_xmd--98ecf";
export var box_flex = "SliderButton-module--box_flex--68481";
export var box_lg = "SliderButton-module--box_lg--8e36e";
export var box_sm = "SliderButton-module--box_sm--4bfab";
export var box_outer = "SliderButton-module--box_outer--d492d";
export var box_whiteBg = "SliderButton-module--box_white-bg--b4c9c";
export var box_noMarginBottom = "SliderButton-module--box_no-margin-bottom--edb16";
export var box_noPadding = "SliderButton-module--box_no-padding--4a143";
export var box_outerGray = "SliderButton-module--box_outer-gray--c80fc";
export var box_dark = "SliderButton-module--box_dark--9affa";
export var box_zIndex = "SliderButton-module--box_z-index--71fd2";
export var box_zIndex6 = "SliderButton-module--box_z-index-6--7a910";
export var box_eventsWithLine = "SliderButton-module--box_events-with-line--19d85";
export var box_featuresAo = "SliderButton-module--box_features-ao--aa7c9";
export var box_verticalPaddings = "SliderButton-module--box_vertical-paddings--d90b2";
export var clearP = "SliderButton-module--clearP--de1b9";
export var clearP_vc = "SliderButton-module--clearP_vc--21d87";
export var wrapper = "SliderButton-module--wrapper--92351";
export var item = "SliderButton-module--item--e5e8d";
export var progressDataWrapper = "SliderButton-module--progressDataWrapper--2c2ab";
export var arrowIcon = "SliderButton-module--arrowIcon--996a6";
export var back = "SliderButton-module--back--16b46";
export var circle = "SliderButton-module--circle--f7472";
export var fadeInAnimation = "SliderButton-module--fadeInAnimation--548aa";
export var placeHolderShimmer = "SliderButton-module--placeHolderShimmer--407cf";